import {
  ZodString,
  ZodUndefined,
  string,
  array,
  number,
  object,
  ZodArray,
  ZodTypeAny,
  ZodNumber,
  undefined as undefinedValidation,
  ZodBoolean,
  boolean,
} from 'zod'
import { ZodUnion } from 'zod/lib/src/types/union'

import { VALIDATION_MSG_REQUIRED, VALIDATION_MSG_INVALID_EMAIL } from '../content/alerts'

import { isValidPhoneNumber } from './string'

type StringValidation = ZodUnion<[ZodString, ZodUndefined]> | ZodString

// eslint-disable-next-line @typescript-eslint/ban-types
type OptionalParams<M = {}> = {
  required?: boolean
  message?: {
    required?: string
  } & Partial<M>
}

type StringValidationFn = (params?: OptionalParams) => StringValidation

export const emailValidation: StringValidationFn = (params) => {
  if (params?.required)
    return string()
      .refine((v?: string) => Boolean(v), params?.message?.required || VALIDATION_MSG_REQUIRED)
      .email(VALIDATION_MSG_INVALID_EMAIL)

  return string().email(VALIDATION_MSG_INVALID_EMAIL).optional()
}

export const phoneValidation: StringValidationFn = (params?: OptionalParams) => {
  const validation = string().refine(
    (v) => (v !== '+1' && v ? isValidPhoneNumber(v) : false),
    'invalid phone number'
  )
  if (params?.required)
    return validation.refine(
      (v?: string) => Boolean(v),
      params?.message?.required || VALIDATION_MSG_REQUIRED
    )

  return validation.optional()
}

export const stringValidation: StringValidationFn = (params) => {
  const validation = string().optional()
  if (params?.required)
    return validation.refine(
      (val) => Boolean(val),
      params?.message?.required || VALIDATION_MSG_REQUIRED
    )

  return validation
}

export const numberValidation = (
  params?: OptionalParams
): ZodNumber | ZodUnion<[ZodNumber, ZodUndefined]> => {
  if (params?.required)
    return number().refine(
      (num) => {
        if (typeof num === 'undefined') return false
        if (num === null) return false
        return typeof num === 'number'
      },
      { message: params?.message?.required || 'required' }
    )
  return number().optional()
}

export const booleanValidation = (
  params?: OptionalParams
): ZodBoolean | ZodUnion<[ZodBoolean, ZodUndefined]> => {
  if (params?.required)
    return boolean().refine((val) => typeof val !== 'boolean', {
      message: params.message?.required || 'required',
    })
  return boolean().optional()
}

export const permissionValidation = array(string())

export const validationSchema = object
export const validationUndefined = undefinedValidation
export const validationArray = (
  schema: ZodTypeAny
): ZodUnion<[ZodArray<ZodTypeAny>, ZodUndefined]> => array(schema).optional()
